import React, {useState, useContext} from 'react';
import EditLectureAttendancesModal from './edit-lecture-attendances-modal';
import AttendancesList from './attendances-list';
import { UpdateAllAttendances } from '../requests/LectureRequests'
import { DataContext as SharedDataContext } from '../../../stores/crm-store';
import { EDIT_LECTURE_ATTENDANCE_LABEL } from '../../../i18n/keyConstants';
import { useTranslation } from 'react-i18next';


export default function EditLectureAttendances({lecture, open, onClose, refreshLectureData}) {
    const [isSaving, setSaving] = useState(false);
    const [bookingIds, setBookingIds] = useState([]);
    const { t } = useTranslation(['editLectureAttendances']);

    const { dispatch } = useContext(SharedDataContext);


    const handleSave = async () => {
        setSaving(true);
        const response = await UpdateAllAttendances(lecture.id, bookingIds);
        setSaving(false);

        if (response.success) {
            dispatch({ type: 'SHOW_SAVED_TOAST' });
            onClose();
            refreshLectureData();
        } else {
            dispatch({ type: 'SHOW_ERROR_TOAST' });
        }
    }
    
    return (
        <EditLectureAttendancesModal 
            open={open}
            onClose={onClose}
            title={t(EDIT_LECTURE_ATTENDANCE_LABEL)}
            onSave={handleSave}
            isSaving={isSaving}
            >
            <AttendancesList lecture={lecture} bookingIds={bookingIds} setBookingIds={setBookingIds}/>

        </EditLectureAttendancesModal>

    )
}